import { Breadcrumbs } from './Breadcrumbs'

export function PageBanner({
  title,
  breadcrumbs,
  children,
  variant = 'light',
}) {
  return (
    <section
      className={`page-banner page-banner-${variant}`}
      aria-labelledby={title ? 'page-banner-title' : undefined}
    >
      <div className="page-banner-inner">
        {breadcrumbs?.length > 0 && <Breadcrumbs items={breadcrumbs} />}
        {title && (
          <h1 id="page-banner-title" className="page-banner-title">
            {title}
          </h1>
        )}
        {children}
      </div>
    </section>
  )
}
